import { TownsquareSiteAri, TownsquareTagAri } from '@atlassian/ari';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import UpdatesTabAggQuery, {
	type UpdatesTabAggQuery as UpdatesTabAggQueryType,
} from '../ui/Updates/agg/__generated__/UpdatesTabAggQuery.graphql';

const getTagAri = (tagUuid: string, siteId: string): string => {
	return TownsquareTagAri.create({
		tagUuid,
		siteId,
	}).toString();
};

export const topicUpdatesAggResource = createRelayResource<UpdatesTabAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const tagUuid = routerContext.match.params.uuid ?? '';
		const rawCloudId = context.workspace?.cloudId;
		if (!rawCloudId) throw new Error('No cloudId available');

		return {
			query: UpdatesTabAggQuery,
			variables: {
				tagId: getTagAri(tagUuid, rawCloudId),
				containerId: TownsquareSiteAri.create({ siteId: rawCloudId }).toString(),
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
			cacheKey: `topic-updates-agg-${tagUuid}`,
		};
	},
});
